import { ApolloClient, InMemoryCache, gql, useMutation, useQuery } from "@apollo/client";
import * as React from 'react'
import {useState, useEffect} from 'react'
import { useRouter } from 'next/router';

import MenuComponent from '../components/menu';
import { GetStaticProps } from "next";

import {Queries} from  "../services/queries";
import {ActiveCustomer } from "../components/contracts/types";
import User from "../components/user";
import {APISERVER, TURNSTILE_SITEKEY} from "../services/globals";
import { Turnstile } from '@marsidev/react-turnstile';


const POSTFORM = APISERVER + '/../postform';

interface Contact_form {
  email : string;
  name : string;
  content : string;
  token : string; 
  extradata : string;
}

interface Json_obj {
  [key: string]: string;
}

export default function contact_form({categories}) {

  const [count, setCount] = useState<number | null>(null);
    
  useEffect(() => {
    async function getstartcount ()  {
      let mycount : number = -1;
      const queries = new Queries(null);
      mycount = await queries.getCartCount();
//        console.log("getstartcount: " + mycount);
      setCount(mycount);
    }

    getstartcount();
  }, []);



    const queries = new Queries(null);
    const activeCustomer:ActiveCustomer = queries.getActiveCustomer();

    let username="";
    let email = "";
    if (activeCustomer?.firstName && activeCustomer?.lastName) {
         username = activeCustomer.firstName + " " + activeCustomer.lastName;
        email = activeCustomer.emailAddress;
    }

    const formref = React.useRef<HTMLFormElement>(null);

    const [emailerr, setemailerr] = useState('');
    const [nameerr, setnameerr] = useState('');
    const [contenterr, setcontenterr] = useState('');

    const [inputs, setinputs] = useState({email: '', name: '', content:  '', token: '', extradata: ''});

    const handleChange = (event) => {
      const name = event.target.name;
      const value = event.target.value;
      setinputs(values => ({...values, [name]: value}));
    }


    async function onSuccess(inputs: Contact_form, jsondata: string) : Promise<string> {
      //alert("onSuccess");
      //alert(jsondata);

      const success = String(await queries.sendFormData(inputs.email,inputs.token, jsondata));
      //alert(JSON.stringify(success));

      if ( success == "true") {
        alert("Form successfully send");
        setinputs({name: "",email: "",content: "",token:"", extradata:""});
      } else {
        alert("Form not processed");
      }
      return success;
    } 

const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

async function handleSubmit (event) {
  event.preventDefault();
  const formData = new FormData(formref.current)
  let data : Json_obj = {};
  for (let key  of formData.keys()) {
      data[key] = String(formData.get(key));
  }
  
  inputs.token = String(formData.get('cf-turnstile-response'));
  inputs.email = String(formData.get('email'))
  inputs.name = String(formData.get('name'))
  inputs.content = String(formData.get('content'))
  let errcount = 0;
  if (inputs.email.length < 6) {
    setemailerr("notwendig");
    ++errcount;
  } else if (!inputs.email.match(emailRegex)) {
    setemailerr("ungültige E-Mail");
    ++errcount;
   
  } else {setemailerr("");}

  if (inputs.name.length < 2) {
    setnameerr("notwendig");
    ++errcount;
  } else {setnameerr("");
}
  if (inputs.content.length < 3) {
    setcontenterr("notwendig");
    ++errcount;
  } else {setcontenterr("");}

  if (inputs.token.length < 80) {
    ++errcount;
  }
  if (!errcount) {
    onSuccess(inputs,JSON.stringify(data));
    //alert(stringify(inputs));
    //router.reload();
  
  } else {
    alert("Formular wegen Fehler nicht gesendet!")
  }  
}

  return ( 
    <div>
    <div>
       <MenuComponent collections={categories.collections}></MenuComponent>
    </div>

    <div className="container-fluid">


    <div><h2>Kontakt-Formular</h2></div>
    <div className="row">
     <div className="col-md-3"></div> 
    <div className="col-md-6 borderbox checkout1">

    <form ref={formref} onSubmit={handleSubmit} >

            <div className="mb-3">    
            <label htmlFor="email" className="form-label-sm">E-Mail *</label>   
            <input className="form-control" id="email" name="email" value={inputs.email || email} onChange={handleChange}  />
            <div className="error-msg">{emailerr}</div>
            </div>
            <div className="mb-3">    
            <label htmlFor="name" className="form-label-sm">Name *</label>   
            <input className="form-control" id="name" name="name" value={inputs.name || username} onChange={handleChange}   />
            <div className="error-msg">{nameerr}</div>
            </div>

            <div className="mb-3">    
            <label htmlFor="content" className="form-label-sm">Nachricht *</label>   
            <textarea className="form-control" id="content" name="content" value={inputs.content} onChange={handleChange}  />
            <div className="error-msg">{contenterr}</div>
            </div>

            <div className="mb-3">    
            <label htmlFor="extradata" className="form-label-sm">Extradata</label>   
            <textarea className="form-control" id="extradata" name="extradata" value={inputs.extradata} onChange={handleChange}  />
            <div className="error-msg">{contenterr}</div>
            </div>

            <Turnstile siteKey={TURNSTILE_SITEKEY} />
            <button className="btn btn-primary" type="submit">Absenden</button>
            </form>
            
    </div>
    <div className="col-md-3"></div>
    </div>    

    </div>
    </div>
  );
};

export const getStaticProps: GetStaticProps = async (context) => {
  //  console.log("+++++++ " + context);
    const queries = new Queries(null);
    const categories = await queries.getCategories(); 
  //  console.log("+++++++------ " + JSON.stringify(categories));
    return {
      props: {
        categories: categories
      },
    };
  };

